import b from 'b_';
import React from 'react';

import './calendar-plan-showcase__carousel-header_skeleton-view.scss';

export const CalendarPlanShowcaseCarouselHeaderSkeleton = () => {
    return (
        <div className={b('calendar-plan-showcase', 'carousel-header-skeleton')}>
            <div className="skeleton-item" />
        </div>
    );
};
